import React from 'react'
import clsx from 'clsx'
import type { Competition } from '../../types'
import { toCompetitionLogoSrc } from '../../../shared/competitionUrls'
import styles from './styles.module.scss'

type BarItemProps = {
    favorite?: boolean
    structureLibelle?: string
    subtitle?: string;
    href: string
} & Pick<Competition, 'logo' | 'libelle' | 'type'>

const TYPE_LABEL: { [x in Competition['type']]: string } = {
    COUPE_DE_FRANCE: 'Coupe de France',
    NATIONAL: 'National',
    REGIONAL: 'Régional',
    DEPARTEMENTAL: 'Départemental',
    INTER_LIGUES: 'Interligues',
    INTER_COMITES: 'Inter-comités',
}

export const BarItem = ({
    favorite,
    logo,
    libelle,
    type,
    structureLibelle,
    href,
                            subtitle
}: BarItemProps) => (
    <a href={href} className={styles.component} title={libelle}>
        {favorite ? (
            <i className={clsx('fi fi-rs-heart', styles.heart)} title="Competition favorie" />
        ) : null}

        <div className={styles.line}>
            {logo ? (
                <img
                    src={toCompetitionLogoSrc(logo, 64) ?? ''}
                    alt=""
                    title={libelle}
                    className={styles.logo}
                />
            ) : null}
            <div>
                <div className={styles.surtitle}>
                    {TYPE_LABEL[type]}
                    {structureLibelle ? (
                        <>
                            <span className={styles.slash}>/</span>
                            {structureLibelle}
                        </>
                    ) : null}
                </div>
                <div className={styles.name}>{libelle}</div>
                <div className={styles.subtitle}>{subtitle}</div>
            </div>
        </div>
    </a>
)
